import { Fragment } from "react";
import DataTable from "react-data-table-component";
import { TrendingDown, TrendingUp } from "react-feather";
import { Badges, H3, H6 } from "../../../../AbstractElements";
import {
  convertDateTime,
  formatCurrency,
} from "../../../../Library/custom_utils";
import MothriftLoader from "../../Common/MothriftLoader";

const TransactionTable = ({
  data,
  isLoading,
  totalRows,
  currentPage,
  onPageChange,
  limit,
}) => {
  const renderItem = (item) => {
    // Corrected Name mapping from backend enrichment
    const customerName =
      `${item.firstName || ""} ${item.lastName || ""}`.trim() || "N/A";

    // Deep mapping for nested bank details
    const bankName =
      item.bankName ||
      item.details?.bankName ||
      item.details?.data?.sourceInformation?.bankName ||
      "N/A";
    const accountNumber = item?.details?.data?.sourceInformation?.sourceAccountNumber || item?.details?.beneficiaryAccountNumber || '0000000000' || 'N/A';

    const statusColor =
      item.status === "Success"
        ? "success"
        : item.status === "Pending"
          ? "info"
          : "danger";

    return {
      ...item, // keep original data for reference
      formattedName: (
        <H6 attrH6={{ className: "f-14 text-uppercase f-light" }}>
          {customerName}
        </H6>
      ),
      formattedUser: (
        <H6 attrH6={{ className: "f-14 f-light" }}>{item.userId}</H6>
      ),
      formattedAmount: (
        <div className="d-flex">
          {item.type === "Deposit" ? (
            <TrendingUp className="font-success me-2" />
          ) : (
            <TrendingDown className="font-danger me-2" />
          )}
          <div>
            <H6 attrH6={{ className: "f-14 mb-2" }}>
              {item.type?.toUpperCase()}
            </H6>
            <H3 attrH3={{ className: "f-14 mb-0 f-light" }}>
              {formatCurrency(item.amount)}
            </H3>
          </div>
        </div>
      ),
      formattedDate: (
        <H6 attrH6={{ className: "f-14 mb-0 f-light" }}>
          {convertDateTime(item.createdAt)}
        </H6>
      ),
      formattedBank: (
        <H6 attrH6={{ className: "f-14 mb-0 f-light" }}>{bankName}</H6>
      ),
      formattedAccount: (
        <H6 attrH6={{ className: "f-14 mb-0 f-light" }}>{accountNumber}</H6>
      ),
      formattedStatus: (
        <Badges
          attrBadge={{
            className: "badge rounded-pill",
            color: statusColor,
            pill: true,
            style: { minWidth: 70 },
          }}>
          {item.status}
        </Badges>
      ),
      formattedBalance: (
        <span className="font-success font18-bold">
          {formatCurrency(item.totalAmount)}
        </span>
      ),
    };
  };

  const columns = [
    {
      name: "Customer Name",
      selector: (row) => row.formattedName,
      width: "180px",
    },
    { name: "User ID", selector: (row) => row.formattedUser, width: "140px" },
    { name: "Amount", selector: (row) => row.formattedAmount },
    { name: "Date/Time", selector: (row) => row.formattedDate, center: true },
    { name: "Bank Name", selector: (row) => row.formattedBank, center: true },
    {
      name: "Bank Account",
      selector: (row) => row.formattedAccount,
      center: true,
    },
    {
      name: "Wallet Balance",
      selector: (row) => row.formattedBalance,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.formattedStatus,
      center: true,
      width: "100px",
    },
  ];

  const processedData = data.map((item) => renderItem(item));

  return (
    <Fragment>
      {isLoading ? (
        <MothriftLoader />
      ) : (
        <DataTable
          data={processedData}
          columns={columns}
          striped
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={limit}
          paginationDefaultPage={currentPage}
          onChangePage={onPageChange}
          paginationResetDefaultPage={false} // Prevents jumping to page 1 on data reload
          persistTableHead
        />
      )}
    </Fragment>
  );
};

export default TransactionTable;
